module.exports = __webpack_public_path__ + "img/result.2f7cefec.svg";